import { Container, Grid } from '@mui/material';
import SplashScreen from 'pages/SplashScreen';
import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import Footer from './Footer';
import Header from './Header';

const MainContent = () => (
  <Suspense fallback={<SplashScreen />}>
    <Outlet />
  </Suspense>
);

export const Layout = () => {
  return (
    <Container 
      maxWidth={"xl"}
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        padding: '0 24px !important',
        overflowX: 'clip'
      }}
    >
      <Grid component='header' sx={{ width: '100%' }}>
        <Header />
      </Grid>
      <Grid 
        className="body-container" 
        sx={{ 
          flex: 1,
          width: '100%',
          padding: '20px 0'
        }}
      >
        <MainContent />
      </Grid>
      <Grid component='footer' sx={{ marginTop: 'auto', width: '100%' }}>
        <Footer />
      </Grid>
    </Container>
  );
};
